export enum Topic {
	SubmitEvent = 'tracking.event.submitEvent',
	MergeEvent = 'tracking.event.addToPageImpression',
	NextPageEvent = 'tracking.event.trackOnNextPageImpression',
	MoveEvent = 'tracking.event.submitMove',
	SubmitPageImpression = 'tracking.event.submitPageImpression',
	AddFeaturesToPageImpression = 'tracking.event.addFeaturesToPageImpression',
	AddActionToEvent = 'tracking.event.addActionToEvent',
	SubmitMiniAction = 'tracking.event.submitMiniAction'
}
